import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAutocomplete from "../../../../../components/mui/form/autocomplete/autocomplete";
import { API } from "../../../../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../../helpers/errorHandling";
import useUserAction from "../../../../../hooks/user/useUserAction";
import useUserData from "../../../../../hooks/user/useUserData";
import { ISSUES_FORM } from "../../../locales/namespaces";

const ItemAutoComplete = (props) => {
	const { token, isLoggedIn } = useUserData()
	const { userLogout } = useUserAction()
	const [items, setItems] = useState(props.items);
	const [loadingItems, setLoadingItems] = useState(false)
	const { t } = useTranslation(ISSUES_FORM)
	
	const handleSearch = (evt, name) => {
		setLoadingItems(true)
		axios({
			method: 'post',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			data: { 'query': evt.target.value, "ItemType": "item" },
			url: `${API}/en/item/search`
		}).then((response) => {
			setItems(response.data.data)
			setLoadingItems(false)
		}).catch((error) => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			setLoadingItems(false)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	return (
		<CustomAutocomplete
			loading={loadingItems}
			identifier={'id'}
			value={props.value}
			onChange={(evt, newValue, reason) => {
				props.onChange(evt, newValue, reason)
			}}
			onBlur={props.handleBlur}
			options={items}
			labelKey={'Description'}
			onInputChange={(event) => handleSearch(event, 'items')}
			otherprops={{
				selectOnFocus: true,
				getOptionKey: (option) => (option.id)
			}}
		/>
	
	);
};

export default ItemAutoComplete